import { useCallback } from 'react';
import { useLocalStorage } from '@alltrails/local-storage';

export const VIEWED_LOCATION_PAGE_STORAGE_KEY = 'viewed-location-page';

const useViewedLocationPage = () => {
  const { getValue, setValue } = useLocalStorage<boolean>(VIEWED_LOCATION_PAGE_STORAGE_KEY, null);

  const markViewedLocationPage = useCallback(() => {
    setValue(true);
  }, [setValue]);

  const hasViewedLocationPage = getValue() === true;

  return { hasViewedLocationPage, markViewedLocationPage };
};

export default useViewedLocationPage;
